    import React, { useState, useEffect, useMemo } from "react";
    import classnames from "classnames";
    import { Link } from "react-router-dom";
    import {
    Col, Row, Card, CardBody, Nav, NavItem, NavLink,
    TabContent, TabPane, Badge, Button, UncontrolledTooltip, Input, Spinner,
    Modal, ModalHeader, ModalBody, Table,
    ModalFooter
} from "reactstrap";
    import { toast, ToastContainer } from "react-toastify";
    import "react-toastify/dist/ReactToastify.css";
    import TableContainer from '../../../components/Common/TableContainer';
    import Breadcrumbs from '../../../components/Common/Breadcrumb';
    import { liveFirestore } from "../../../helpers/firebase_live";

    const UygunGeziler = () => {
        document.title = "Uygun İşler | Lojgo";

        const authUser = JSON.parse(localStorage.getItem("authUser"));
    const userId = authUser?.ID;
    const userType = Number(authUser?.Users_Type_ID);

    const isCustomer = userType === 1; // Müşteri
    const isDriver = userType === 2 || userType === 4;   // Sürücü / Çekici
    const isAdmin = userType === 3;    // Admin

    // Çekici Sertifikası kontrolü (Users_Document.TowingCertificate)
    // Sertifikası varsa "çekici sürücüsü" olarak hem sürücü hem çekici işine teklif verebilir.
    const [hasTowingCert, setHasTowingCert] = useState(false);

    useEffect(() => {
        const fetchTowingCert = async () => {
            if (!userId || !isDriver) return;
            try {
                const res = await fetch(`https://hiflowapi.stechomeyazilim.info/Users_Document?$filter=Users_ID eq ${userId}`);
                if (!res.ok) return;
                const data = await res.json();
                const doc = (data?.value && data.value[0]) || null;
                const cert = doc?.TowingCertificate;
                setHasTowingCert(!!(cert && String(cert).trim().length > 0));
            } catch (e) {
                console.error("Çekici sertifikası kontrol edilemedi:", e);
            }
        };
        fetchTowingCert();
    }, [userId, isDriver]);

    // Toggle loading & confirm modal
    const [togglingId,   setTogglingId]   = useState(null);
    const [confirmToggle, setConfirmToggle] = useState(null); // { id, newStatus }
    const [rejectModal,  setRejectModal]  = useState(null);  // { offerId }
    const [rejectReason, setRejectReason] = useState("");

    // --- YENİ EKLENEN: Teklif Masraf Detayı Modalı State'leri ---
    const [expenseDetailModalOpen, setExpenseDetailModalOpen] = useState(false);
    const [viewExpenseDetail, setViewExpenseDetail] = useState(null);

    const openExpenseDetailModal = (offer) => {
        // İlgili teklifin masrafını (Advert_Expenses) state'e atıp modalı açıyoruz
        const expDetail = (offer.Advert_Expenses && offer.Advert_Expenses.length > 0) ? offer.Advert_Expenses[0] : null;
        setViewExpenseDetail(expDetail);
        setExpenseDetailModalOpen(true);
    };

        const [activeTab, setActiveTab] = useState("1");
        
        // Aktif İlanlar (Tüm uygun geziler) State'leri
        const [tripsData, setTripsData] = useState([]);
        const [isLoadingTrips, setIsLoadingTrips] = useState(false);
        const [liveLocationIds, setLiveLocationIds] = useState(new Set());

        // Kullanıcının Teklifleri (Alıntılarım) State'leri
        const [quotesData, setQuotesData] = useState([]);
        const [isLoadingQuotes, setIsLoadingQuotes] = useState(false);

        const [statusFilter, setStatusFilter] = useState('all'); // 'all', 'approved', 'pending'

        // Teklif Modalı State'leri
    const [isOffersModalOpen, setIsOffersModalOpen] = useState(false);
    const [selectedAdvertForOffers, setSelectedAdvertForOffers] = useState(null);
    const [isOffersModalLoading, setIsOffersModalLoading] = useState(false);

    // Masraflar Modalı State'leri
    const [isExpensesModalOpen, setIsExpensesModalOpen] = useState(false);
    const [selectedAdvertForExpenses, setSelectedAdvertForExpenses] = useState(null);
    const [isExpensesModalLoading, setIsExpensesModalLoading] = useState(false);

    const toggleOffersModal = () => setIsOffersModalOpen(!isOffersModalOpen);
    const toggleExpensesModal = () => setIsExpensesModalOpen(!isExpensesModalOpen);

    const openOffersModal = async (row) => {
        setSelectedAdvertForOffers({ ...row, allOffers: [] });
        setIsOffersModalOpen(true);
        setIsOffersModalLoading(true);
        try {
           const res = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers?$filter=Advert_ID eq ${row.id}&$expand=Users,Advert_Expenses&$orderby=ID desc`);
            const data = await res.json();
            setSelectedAdvertForOffers({ ...row, allOffers: data.value || [] });
        } catch (e) {
            console.error("Teklifler yüklenemedi:", e);
        } finally {
            setIsOffersModalLoading(false);
        }
    };

    const openExpensesModal = async (row) => {
        setSelectedAdvertForExpenses({ ...row, pricings: [] });
        setIsExpensesModalOpen(true);
        setIsExpensesModalLoading(true);
        try {
            const res = await fetch(`https://hiflowapi.stechomeyazilim.info/Users_Advert_Pricing?$filter=Advert_ID eq ${row.id}&$expand=Advert_Pricing&$orderby=ID desc`);
            const data = await res.json();
            setSelectedAdvertForExpenses({ ...row, pricings: data.value || [] });
        } catch (e) {
            console.error("Masraflar yüklenemedi:", e);
        } finally {
            setIsExpensesModalLoading(false);
        }
    };

        const toggleTab = (tab) => {
            if (activeTab !== tab) {
                setActiveTab(tab);
            }
        };

        const filteredTripsData = useMemo(() => {
            return tripsData.filter(trip => {
                // Sadece admin bu filtreyi kullanacağı için, admin değilse tümünü (kendi ilanlarını) göster
                if (!isAdmin) return true; 
                
                if (statusFilter === 'approved') return trip.isAdminCheck === true;
                if (statusFilter === 'pending') return trip.isAdminCheck === false;
                return true; // 'all' durumu
            });
        }, [tripsData, statusFilter, isAdmin]);

    useEffect(() => {
        const fetchLiveLocations = async () => {
            try {
                const snapshot = await liveFirestore.collection("live_locations").where("isActive", "==", true).get();
                const ids = new Set(snapshot.docs.map(doc => doc.id));
                setLiveLocationIds(ids);
            } catch (e) {
                console.error("Canlı konum ID'leri alınamadı:", e);
            }
        };
        fetchLiveLocations();
    }, []);

    useEffect(() => {
        const fetchAdverts = async () => {
            setIsLoadingTrips(true);
            try {
                let filter = "";
                
                if (isCustomer) {
                    filter = `$filter=Users_ID eq ${userId}&$top=100&$orderby=Created_DateTime desc&`;
                } else if (isDriver) {
                    filter = `$filter=Is_AdminCheck eq true and Is_Active eq true&$top=100&$orderby=Created_DateTime desc&`;
                } else if (isAdmin) {
                    filter = `$top=100&$orderby=Created_DateTime desc&`;
                }

                // Admin: sadece sayım için ID'leri çek (hafif)
                // Sürücü/Müşteri: sadece kendi teklifi
                let expandExtra = "";
                if (isAdmin) {
                    // Admin için de Offer_Status bilgisini çekiyoruz
                    expandExtra = `,Advert_Offers($select=ID,Offer_Status),Users_Advert_Pricing($select=ID)`;
                } else if (isDriver || isCustomer) {
                    // $filter=Users_ID kısmını KALDIRDIK. Artık ilandaki diğer kişilerin de "Kabul Edildi" durumunu görebileceğiz.
                    expandExtra = `,Advert_Offers($select=ID,Users_ID,Offer_Status,Price,Own_Offer,Quickly)`;
                }

                const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert?${filter}$expand=Users_Car,Advert_Location${expandExtra}`);
                const result = await response.json();

                    if (result && result.value) {
                    const formattedData = result.value.map(item => {
    const car = item.Users_Car || {};
        const location = item.Advert_Location?.[0] || {}; 
        const invoice = item.Invoince || null;
        const advertType = item.Advert_Type || {};
        const offers = item.Advert_Offers || [];
        
        // Bu ilanda KULLANICININ kendi teklifi var mı?
        const myOffer = offers.find(offer => offer.Users_ID === userId);

        return {
            id: item.ID,
            advertTypeId: item.Advert_Type_ID || 1,
            direction: item.Direction_Type || "Belirtilmedi",
            advertTypeTitle: advertType.Advert_Type_Title || "Standart İlan",
            
            startCity: `${location.Start_City_Code || ''} ${location.Advert_Location_StartAddress?.split(',')[0] || ''}`,
            endCity: `${location.Finish_City_Code || ''} ${location.Advert_Location_FinishAddress?.split(',')[0] || ''}`,
            startAddress: location.Advert_Location_StartAddress || '',
            endAddress: location.Advert_Location_FinishAddress || '',
            
            // Zaman Planlaması
            startDate: item.Advert_DateTime ? new Date(item.Advert_DateTime).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' }) : "-",
            endDate: item.Advert_DateTime2 ? new Date(item.Advert_DateTime2).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' }) : "-",
            deadline: item.Advert_DateTime3 ? new Date(item.Advert_DateTime3).toLocaleDateString('tr-TR') : "-", // 3. Zaman (genelde teslim tarihi)
            
            customer: item.Customer_Notes || "Not yok",
            
            // Araç Bilgileri
            carBody: car.Car_Body_Type || "-", 
            engine: car.Engine_Type || "-",   
            brand: car.Users_Car_Brand || "-",
            model: car.Users_Car_Model || "-",
            
            // Operasyonel Veriler
            distance: item.Advert_KM ? `${item.Advert_KM} km` : (location.Km ? `${location.Km} km` : "-"),
            duration: item.Estimated_Duration || "-", 
            fuelStatus: item.Fuel_Status || "Bilinmiyor",
            
            // Finans ve Onay
            price: item.Price || 0,
            quickOfferPrice: item.Quick_Offer_Price ?? null,
            invoiceId: item.Invoince_ID,
            invoiceNo: invoice ? invoice.Invoince_Number : null,
            invoiceStatus: invoice ? invoice.Invoince_Status : "Bekliyor",
            
            isAdminCheck: item.Is_AdminCheck,
            isActive: item.Is_Active,

            hasOffer: !!myOffer,
        myOfferPrice: myOffer ? (myOffer.Price || myOffer.Own_Offer) : 0,
        myOfferStatus: myOffer ? myOffer.Offer_Status : "Bekliyor",

      offersCount: (item.Advert_Offers || []).length,
        expensesCount: (item.Users_Advert_Pricing || []).length,
        allOffers: offers
        };
    });

                // İşi başkasına verilmiş (Kabul Edilmiş / Onaylanmış) ilanları süz
    const availableTrips = formattedData.filter(trip => {
        const isJobTaken = trip.allOffers.some(offer => {
            const status = offer.Offer_Status ? offer.Offer_Status.toLowerCase() : "";
            return status.includes("kabul") || status.includes("onay");
        });
        return !isJobTaken; // Sadece işi henüz alınmamış olanları döndür
    });

    setTripsData(availableTrips);

                    }
                } catch (error) {
                    console.error("İlanlar çekilirken hata oluştu:", error);
                } finally {
                    setIsLoadingTrips(false);
                }
            };

            fetchAdverts();
        }, []);


        // 2. OData API'den TEKLİFLERİ Çekme İşlemi
useEffect(() => {
    const fetchMyQuotes = async () => {
        if (!userId) return;
        setIsLoadingQuotes(true);
        try {
            let quoteFilter = "";

            if (isAdmin) {
                // Admin her şeyi görür
                quoteFilter = "$top=1000&$orderby=ID desc";
            } else if (isCustomer || isDriver) {
                // Müşteri veya Sürücü sadece KENDİ verdiği teklifleri görür
                quoteFilter = `$filter=Users_ID eq ${userId}&$top=1000&$orderby=ID desc`;
            }

           const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers?${quoteFilter}&$expand=Users,Advert_Expenses`);
            const result = await response.json();

            if (result && result.value) {
                const formattedQuotes = result.value.map(item => ({
                    offerId: item.ID,
                    advertId: item.Advert_ID || "-",
                    date: item.Created_DateTime ? new Date(item.Created_DateTime).toLocaleDateString('tr-TR') : "-",
                    price: item.Price || item.Own_Offer || 0,
                    ownOffer: item.Own_Offer || 0,
                    // Yeni tablodan (Advert_Expenses) gelen Total_Expense değerini alıyoruz
                    travelExpenses: (item.Advert_Expenses && item.Advert_Expenses.length > 0) 
                        ? item.Advert_Expenses[0].Total_Expense 
                        : (item.Travel_Expenses || 0),
                    status: item.Offer_Status || "Bekliyor",
                    quickly: item.Quickly || false,
                    isUpdated: item.IsUpdated || false,
                    deliveryDate: item.Delivery_Date ? new Date(item.Delivery_Date).toLocaleDateString('tr-TR') : "-",
                    driverName: item.Users ? item.Users.Users_NameSurname : "Bilinmiyor"
                }));

                setQuotesData(formattedQuotes);
            } else {
                setQuotesData([]);
            }
        } catch (error) {
            console.error("Teklifler çekilirken hata:", error);
            setQuotesData([]);
        } finally {
            setIsLoadingQuotes(false);
        }
    };
    fetchMyQuotes();
}, [isAdmin, isCustomer, isDriver, userId]); // Bağımlılıkları güncelledik


    // İlan Aktif/Pasif Toggle
    const handleToggleConfirm = async () => {
        if (!confirmToggle) return;
        const { id, newStatus } = confirmToggle;
        setConfirmToggle(null);
        setTogglingId(id);
        try {
            const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert(${id})`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ Is_AdminCheck: newStatus }),
            });
            if (response.ok) {
                setTripsData(prev => prev.map(item =>
                    item.id === id ? { ...item, isAdminCheck: newStatus } : item
                ));
                toast.success(
                    `İlan #${id} başarıyla ${newStatus ? 'AKTİF' : 'PASİF'} yapıldı.`,
                    { position: "top-right", autoClose: 3000 }
                );
            } else {
                toast.error("İlan durumu güncellenirken bir hata oluştu.", { position: "top-right" });
            }
        } catch {
            toast.error("Bağlantı hatası! Lütfen tekrar deneyin.", { position: "top-right" });
        } finally {
            setTogglingId(null);
        }
    };

    // Admin Teklif Onay/Red İşlemi
    const handleOfferStatusUpdate = async (offerId, newStatus, rejectionReason = null) => {
        try {
            const payload = {
                Offer_Status: newStatus,
                ReasonForRejection: newStatus === 'Reddedildi' ? rejectionReason : null
            };

            const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers(${offerId})`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                setSelectedAdvertForOffers(prev => ({
                    ...prev,
                    allOffers: prev.allOffers.map(o => o.ID === offerId ? { ...o, Offer_Status: newStatus, ReasonForRejection: payload.ReasonForRejection } : o)
                }));
                setTripsData(prevTrips => prevTrips.map(trip => {
                    if (trip.id === selectedAdvertForOffers.id) {
                        return {
                            ...trip,
                            allOffers: trip.allOffers.map(o => o.ID === offerId ? { ...o, Offer_Status: newStatus, ReasonForRejection: payload.ReasonForRejection } : o)
                        };
                    }
                    return trip;
                }));
                toast.success(`Teklif #${offerId} "${newStatus}" olarak güncellendi.`, { position: "top-right", autoClose: 3000 });
            } else {
                toast.error("Teklif durumu güncellenirken bir hata oluştu.", { position: "top-right" });
            }
        } catch {
            toast.error("Bağlantı hatası!", { position: "top-right" });
        }
    };

    const tripsColumns = useMemo(
        () => [
            {
                header: 'Kimlik / Tip',
                accessorKey: "id",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div>
                            <span className="text-body fw-bold">#{row.id}</span><br />
                            {row.advertTypeId === 2
                                ? <Badge color="warning" className="mb-1"><i className="mdi mdi-tow-truck me-1"></i>Çekici İşi</Badge>
                                : <Badge color="primary" className="mb-1"><i className="mdi mdi-car me-1"></i>Sürücü İşi</Badge>
                            }<br />
                            <Badge className={row.direction.includes("Git") ? "bg-primary" : "bg-secondary"}>
                                {row.direction}
                            </Badge>
                        </div>
                    );
                }
            },
            {
                header: 'Güzergah',
                accessorKey: "startCity",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(row.startAddress || row.startCity)}&destination=${encodeURIComponent(row.endAddress || row.endCity)}`;
                    return (
                        <div style={{ minWidth: 160 }}>
                            {/* Kalkış */}
                            <div className="d-flex align-items-start gap-2 mb-1">
                                <div style={{
                                    width: 10, height: 10, borderRadius: '50%',
                                    background: '#28a745', flexShrink: 0, marginTop: 4
                                }} />
                                <div>
                                    <div className="fw-bold text-success" style={{ fontSize: 12 }}>{row.startCity}</div>
                                    {row.startAddress && (
                                        <div className="text-muted" style={{ fontSize: 10, lineHeight: 1.3 }}>
                                            {row.startAddress.length > 45 ? row.startAddress.substring(0, 45) + '…' : row.startAddress}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* Çizgi */}
                            <div style={{ marginLeft: 4, borderLeft: '2px dashed #dee2e6', height: 12, marginBottom: 1 }} />
                            {/* Varış */}
                            <div className="d-flex align-items-start gap-2 mb-2">
                                <div style={{
                                    width: 10, height: 10, borderRadius: 2,
                                    background: '#dc3545', flexShrink: 0, marginTop: 4
                                }} />
                                <div>
                                    <div className="fw-bold text-danger" style={{ fontSize: 12 }}>{row.endCity}</div>
                                    {row.endAddress && (
                                        <div className="text-muted" style={{ fontSize: 10, lineHeight: 1.3 }}>
                                            {row.endAddress.length > 45 ? row.endAddress.substring(0, 45) + '…' : row.endAddress}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* Rota Oluştur */}
                            <a
                                href={mapsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 4,
                                    fontSize: 11, fontWeight: 600, color: '#fff',
                                    background: 'linear-gradient(135deg, #4285f4, #34a853)',
                                    borderRadius: 6, padding: '3px 8px',
                                    textDecoration: 'none',
                                }}
                            >
                                <i className="mdi mdi-google-maps" style={{ fontSize: 13 }} />
                                Rota Oluştur
                            </a>
                        </div>
                    );
                }
            },
            {
                header: 'Zaman Planı',
                accessorKey: "startDate",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                            <div><strong className="text-success">Bşl:</strong> {row.startDate}</div>
                            <div><strong className="text-danger">Bit:</strong> {row.endDate}</div>
                            {row.deadline !== "-" && <div><strong className="text-muted">Son:</strong> {row.deadline}</div>}
                        </div>
                    );
                }
            },
            {
                header: 'Müşteri / Araç',
                accessorKey: "customer",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    const tooltipId = `carTooltip-${row.id}`;
                    return (
                        <div style={{ maxWidth: "150px" }}>
                            <div className="text-truncate mb-1" title={row.customer}>{row.customer}</div>
                            <div id={tooltipId} style={{ cursor: "pointer", textDecoration: "underline dashed", fontSize: '12px' }}>
                                {row.brand} {row.model}
                            </div>
                            <UncontrolledTooltip target={tooltipId} placement="top">
                                Kasa: {row.carBody} | Motor: {row.engine}
                            </UncontrolledTooltip>
                        </div>
                    );
                }
            },
            {
                header: 'Mesafe / Süre / Yakıt',
                accessorKey: "distance",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div style={{ fontSize: '12px' }}>
                            <div><i className="mdi mdi-road-variant me-1"></i> {row.distance}</div>
                            <div><i className="mdi mdi-clock-outline me-1"></i> {row.duration}</div>
                            <div><i className="mdi mdi-gas-station me-1"></i> {row.fuelStatus}</div>
                        </div>
                    );
                }
            },
            ...(isAdmin || isDriver ? [{
                header: 'Hızlı Teklif',
                accessorKey: "quickOfferPrice",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    const hasQuick = row.quickOfferPrice != null && Number(row.quickOfferPrice) > 0;
                    const display = hasQuick
                        ? Number(row.quickOfferPrice)
                        : isDriver ? Number(row.price || 0) : "—";
                    return (
                        <div>
                            <div className="fw-bold mb-1 text-warning">
                                <i className="mdi mdi-flash me-1"></i>{typeof display === 'number' ? display.toFixed(2) : display} TL
                            </div>
                            {row.invoiceId ? (
                                <Badge color={row.invoiceStatus === 'Ödendi' ? 'success' : 'warning'}>
                                    Fatura: {row.invoiceNo || "Kesildi"}
                                </Badge>
                            ) : (
                                <Badge color="light" className="text-muted border">Fatura Yok</Badge>
                            )}
                        </div>
                    );
                }
            }] : []),

            ...(isAdmin || isCustomer ? [{
                header: 'Fiyat / Net / Yol',
                accessorKey: "price",
                enableSorting: true,
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div style={{fontSize:"12px"}}>
                            <div className="fw-bold text-primary">{Number(row.price).toFixed(2)} ₺</div>
                            <div className="text-muted">Net: {Number(row.ownOffer).toFixed(2)} ₺</div>
                            <div className="text-muted">Yol: {Number(row.travelExpenses).toFixed(2)} ₺</div>
                        </div>
                    );
                }
            }] : []),

            {
                header: 'Sistem Durumu',
                accessorKey: "isAdminCheck",
                cell: (cellProps) => {
                    const isChecked = cellProps.row.original.isAdminCheck;
                    return isChecked 
                        ? <Badge color="success">Aktif (Onaylı)</Badge>
                        : <Badge color="danger">Pasif (Bekliyor)</Badge>;
                }
            },
        {
        header: 'Eylemler',
        enableSorting: false,
        cell: (cellProps) => {
            const row = cellProps.row.original;
            const isToggling = togglingId === row.id;

            return (
                <div className="d-flex flex-column gap-1">
                    <Link to={`/job-details/${row.id}`} className="btn btn-light btn-sm border-secondary text-dark">
                        Detaylar
                    </Link>

                    {/* MÜŞTERİ veya ADMİN: Canlı Konum */}
                    {(isAdmin || isCustomer) && liveLocationIds.has(`mission_${row.id}`) && (
                        <Link to={`/job-live-location/${row.id}`} className="btn btn-success btn-sm">
                            <i className="mdi mdi-map-marker-radius me-1"></i> Konum
                        </Link>
                    )}

                    {/* SÜRÜCÜ veya MÜŞTERİ: Teklif Durumu veya Teklif Ver butonu */}
                    {(isDriver || isCustomer) && (
                        row.hasOffer ? (
                            <div className="border border-info rounded p-1 text-center bg-soft-info mt-1">
                                <span className="d-block text-info fw-bold" style={{fontSize: "11px"}}>
                                    <i className="mdi mdi-check-all"></i> Teklifiniz: {row.myOfferPrice} ₺
                                </span>
                                <Badge color={
                                    row.myOfferStatus?.includes('Kabul') ? "success" :
                                    row.myOfferStatus?.includes('Red') ? "danger" : "warning"
                                } style={{fontSize: "10px", marginTop: "2px"}}>
                                    {row.myOfferStatus || "Bekliyor"}
                                </Badge>
                            </div>
                        ) : (
                            // Sürücü çekici işine yalnızca çekici sertifikası varsa teklif verebilir
                            (isDriver && row.advertTypeId === 2 && !hasTowingCert) ? (
                                <div className="border border-warning rounded p-1 text-center bg-soft-warning mt-1" title="Bu görev çekici sertifikası gerektirir.">
                                    <span className="d-block text-warning fw-bold" style={{fontSize: "10px"}}>
                                        <i className="mdi mdi-lock-outline me-1"></i>Çekici sertifikası gerekli
                                    </span>
                                </div>
                            ) : (
                                <Link to={`/job-details/${row.id}`} className="btn btn-warning btn-sm mt-1">
                                    Teklif Ver
                                </Link>
                            )
                        )
                    )}

                    {/* SADECE ADMİN: Onay/Pasif butonları ve Modallar */}
                {isAdmin && (
                    <>
                        <Button
                            color="info"
                            size="sm"
                            onClick={() => openOffersModal(row)}
                        >
                            <i className="mdi mdi-format-list-bulleted me-1"></i> Teklifler
                            {row.offersCount > 0 && (
                                <span className="badge bg-white text-info ms-1">{row.offersCount}</span>
                            )}
                        </Button>
                        <Button
                            color="warning"
                            size="sm"
                            onClick={() => openExpensesModal(row)}
                        >
                            <i className="mdi mdi-receipt me-1"></i> Masraflar
                            {row.expensesCount > 0 && (
                                <span className="badge bg-white text-warning ms-1">{row.expensesCount}</span>
                            )}
                        </Button>
                        <Button
                            color={row.isAdminCheck ? "danger" : "success"}
                            size="sm"
                            outline
                            disabled={isToggling}
                            onClick={() => setConfirmToggle({ id: row.id, newStatus: !row.isAdminCheck })}
                        >
                            {isToggling
                                ? <><Spinner size="sm" className="me-1" />Bekleniyor...</>
                                : row.isAdminCheck ? "Pasife Al" : "Aktif Et"
                            }
                        </Button>
                    </>
                )}
                    
                    {row.invoiceId && (
                        <Link to={`/invoice-view/${row.invoiceId}`} className="btn btn-info btn-sm">
                            Faturayı Gör
                        </Link>
                    )}
                </div>
            );
        }
    }
        ],
        [isAdmin, isDriver, isCustomer, togglingId, hasTowingCert, liveLocationIds]
    );

        // --- ALINTILARIM TABLOSU KOLONLARI ---
    const quotesColumns = useMemo(() => {
        // Önce herkes için ortak olan ilk kolonu koyuyoruz
        let baseColumns = [
            { 
                header: 'Kimlik Alıntı', 
                accessorKey: "offerId", 
                enableSorting: true, 
                cell: (cellProps) => <span className="fw-bold">{cellProps.row.original.offerId}</span> 
            }
        ];

        // EĞER ADMİN İSE: "Sürücü" kolonunu 2. sıraya (index 1) yerleştiriyoruz
        if (isAdmin) {
            baseColumns.push({
                header: 'Sürücü',
                accessorKey: "driverName",
                cell: (cellProps) => <span className="text-primary fw-medium">{cellProps.row.original.driverName}</span>
            });
        }

        // Geri kalan ortak kolonları sona ekliyoruz
        baseColumns = [
            ...baseColumns,
            { header: 'Kimlik Yolculuk', accessorKey: "advertId", enableSorting: true },
            { header: 'Tarih', accessorKey: "date", enableSorting: true },

            ...(isAdmin || isCustomer ? [{
                header: 'Fiyat / Net / Yol',
                accessorKey: "price",
                enableSorting: true,
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div style={{fontSize:"12px"}}>
                            <div className="fw-bold text-primary">{Number(row.price).toFixed(2)} ₺</div>
                            <div className="text-muted">Net: {Number(row.ownOffer).toFixed(2)} ₺</div>
                            <div className="text-muted">Yol: {Number(row.travelExpenses).toFixed(2)} ₺</div>
                        </div>
                    );
                }
            }] : []),

            ...(isAdmin || isDriver ? [{
                header: 'Hızlı Teklif',
                accessorKey: "quickOfferPrice",
                enableSorting: true,
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    const hasQuick = row.quickOfferPrice != null && Number(row.quickOfferPrice) > 0;
                    const display = hasQuick
                        ? Number(row.quickOfferPrice)
                        : isDriver ? Number(row.price || 0) : "—";
                    return (
                        <div>
                            <div className="fw-bold mb-1 text-warning">
                                <i className="mdi mdi-flash me-1"></i>{typeof display === 'number' ? display.toFixed(2) : display} TL
                            </div>
                        </div>
                    );
                }
            }] : []),

            {
                header: 'Tür',
                accessorKey: "quickly",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return row.quickly
                        ? <Badge color="warning"><i className="mdi mdi-flash me-1"></i>Hızlı</Badge>
                        : <Badge color="secondary">Normal</Badge>;
                }
            },
            {
                header: 'Durum',
                accessorKey: "status",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    const status = row.status.toLowerCase();
                    let color = status.includes("kabul") ? "success" : status.includes("red") ? "danger" : "warning";
                    return (
                        <div>
                            <Badge color={color}>{row.status}</Badge>
                            {row.isUpdated && <Badge color="info" className="ms-1">Güncellendi</Badge>}
                        </div>
                    );
                }
            },
            {
                header: 'Eylemler',
                cell: (cellProps) => (
                    <div className="d-flex gap-1 flex-wrap">
                        <Link to={`/job-details/${cellProps.row.original.advertId}`} className="btn btn-light btn-sm border">
                            Göreve Git
                        </Link>
                        {(isAdmin || isCustomer) && liveLocationIds.has(`mission_${cellProps.row.original.advertId}`) && (
                            <Link to={`/job-live-location/${cellProps.row.original.advertId}`} className="btn btn-success btn-sm">
                                <i className="mdi mdi-map-marker-radius me-1"></i> Konum
                            </Link>
                        )}
                    </div>
                )
            }
        ];

        return baseColumns;
    }, [isAdmin, isDriver, isCustomer, liveLocationIds]); // isAdmin değiştiğinde tablo yapısı güncellenir


        return (
            <React.Fragment>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />
                <div className="page-content">
                    <div className="container-fluid">
                        <Row className="mb-3">
        <Col>
            <h2 className="mb-3">Uygun işler</h2>
            <div className="alert alert-warning" role="alert">
                <span className="badge bg-warning me-2">Yeni</span> 
                Bazı görevler yeni bir özellik içerir: tekliflerin anında doğrulanması <Link to="#" className="alert-link text-warning text-decoration-underline">Daha Fazlasını Oku</Link>
            </div>
        </Col>
        <Col className="text-end" md={4}>
            <Button outline color="primary" size="sm" className="me-2">
                <i className="mdi mdi-help-circle-outline me-1"></i> Bir görev nasıl aranır?
            </Button>
            
            {/* SADECE MÜŞTERİ: Yeni Görev Butonu */}
            {isCustomer && (
                <Link to="/create-mission" className="btn btn-primary btn-sm shadow-sm">
                    <i className="mdi mdi-plus me-1"></i> Yeni Görev Talebi Oluştur
                </Link>
            )}
        </Col>
    </Row>

                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody className="pt-0 pb-0 border-bottom">
                                        <Nav tabs className="nav-tabs-custom nav-justified">
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")} style={{ cursor: 'pointer' }}>
                                                    Yakındaki geziler
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")} style={{ cursor: 'pointer' }}>
                                                    Tüm yolculuklar
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3")} style={{ cursor: 'pointer' }}>
                                                    Daha fazla seyahate erişin
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "4" })} onClick={() => toggleTab("4")} style={{ cursor: 'pointer' }}>
                                                    Alıntılarım
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "5" })} onClick={() => toggleTab("5")} style={{ cursor: 'pointer' }}>
                                                    Yardım
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </CardBody>
                                </Card>

                                <TabContent activeTab={activeTab} className="p-3 bg-white mt-2">
                                    
                                    {/* SEKME 1: Yakındaki Geziler */}
                                    <TabPane tabId="1">

                                        {isAdmin && (
                                            <div className="mb-4">
                                                <Nav pills>
                                                    <NavItem>
                                                        <NavLink 
                                                            className={statusFilter === 'all' ? 'active cursor-pointer' : 'cursor-pointer border me-2'} 
                                                            onClick={() => setStatusFilter('all')}
                                                        >
                                                            Tümü
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink 
                                                            className={statusFilter === 'approved' ? 'active bg-success cursor-pointer' : 'cursor-pointer border me-2 text-dark'} 
                                                            onClick={() => setStatusFilter('approved')}
                                                        >
                                                            Onaylı İlanlar
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink 
                                                            className={statusFilter === 'pending' ? 'active bg-warning text-dark cursor-pointer' : 'cursor-pointer border text-dark'} 
                                                            onClick={() => setStatusFilter('pending')}
                                                        >
                                                            Onay Bekleyenler
                                                        </NavLink>
                                                    </NavItem>
                                                </Nav>
                                            </div>
                                        )}

                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="text-muted">Size en yakın rotaların listesi Arama</div>
                                            <div>
                                                <Input type="text" placeholder="Anahtar kelime" style={{width: '250px', display: 'inline-block'}} className="form-control form-control-sm" />
                                                <Button color="light" size="sm" className="ms-1"><i className="mdi mdi-refresh"></i></Button>
                                            </div>
                                        </div>
                                        
                                        {isLoadingTrips ? (
                                            <div className="text-center py-5">
                                                <Spinner color="primary" /> <p className="mt-2">İlanlar yükleniyor...</p>
                                            </div>
                                        ) : (
                                        <TableContainer
        columns={tripsColumns}
        data={filteredTripsData} // tripsData YERİNE BURAYI DEĞİŞTİRDİK
        isCustomPageSize={true}
        isPagination={true}
        tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
    />
                                        )}
                                    </TabPane>

                                    {/* SEKME 2: Tüm Yolculuklar */}
                                    <TabPane tabId="2">
                                        <Row className="mb-3">
                                            <Col md={3}>
                                                <label className="form-label text-muted">Kalkışta filtre</label>
                                                <Input type="select" className="form-select form-select-sm mb-1"><option>Bölüm numarası...</option></Input>
                                                <Input type="select" className="form-select form-select-sm"><option>Tüm bölgeler</option></Input>
                                            </Col>
                                            <Col md={3}>
                                                <label className="form-label text-muted">Varışta filtre</label>
                                                <Input type="select" className="form-select form-select-sm mb-1"><option>Bölüm numarası...</option></Input>
                                                <Input type="select" className="form-select form-select-sm"><option>Tüm bölgeler</option></Input>
                                            </Col>
                                        </Row>
                                        <TableContainer
                                            columns={tripsColumns}
                                            data={tripsData}
                                            isCustomPageSize={true}
                                            isPagination={true}
                                            tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                                        />
                                    </TabPane>

                                    {/* SEKME 3: QR Kod / Uygulama İndir */}
                                    <TabPane tabId="3">
                                        <div className="text-center py-4">
                                            <div style={{
                                                background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
                                                borderRadius: 20, padding: '40px 32px',
                                                maxWidth: 480, margin: '0 auto',
                                                boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                                            }}>
                                                {/* Başlık */}
                                                <div style={{
                                                    background: 'linear-gradient(135deg, #28a745, #20c997)',
                                                    borderRadius: 10, padding: '8px 20px',
                                                    display: 'inline-block', marginBottom: 20
                                                }}>
                                                    <span className="text-white fw-bold" style={{ fontSize: 13 }}>
                                                        <i className="mdi mdi-cellphone me-2"></i>Mobil Uygulamaya Erişin
                                                    </span>
                                                </div>

                                                <h4 className="text-white mb-2">HilflowPartner</h4>
                                                <p className="text-white-50 mb-4" style={{ fontSize: 13 }}>
                                                    Sertifika gerektiren görevler dahil tüm rotalarınıza<br />
                                                    mobil uygulama üzerinden erişebilirsiniz.
                                                </p>

                                                {/* Gerçek QR Kod */}
                                                <div style={{
                                                    background: '#fff', borderRadius: 16,
                                                    padding: 16, display: 'inline-block',
                                                    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                                                    marginBottom: 20
                                                }}>
                                                    <img
                                                        src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent('hilflowpartner://app')}&bgcolor=ffffff&color=1a1a2e&margin=2`}
                                                        alt="HilflowPartner QR Kod"
                                                        width={180}
                                                        height={180}
                                                        style={{ display: 'block', borderRadius: 8 }}
                                                    />
                                                </div>

                                                <p className="text-white-50 mb-4" style={{ fontSize: 12 }}>
                                                    📷 Kameranızı QR koda tutun veya aşağıdan indirin
                                                </p>

                                                {/* Store Butonları */}
                                                <div className="d-flex justify-content-center gap-3 flex-wrap">
                                                    <a
                                                        href="https://apps.apple.com/tr/app/hilflowpartner/id6740601283"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            display: 'inline-flex', alignItems: 'center', gap: 8,
                                                            background: '#000', color: '#fff',
                                                            borderRadius: 10, padding: '10px 18px',
                                                            textDecoration: 'none', fontSize: 13, fontWeight: 600
                                                        }}
                                                    >
                                                        <i className="mdi mdi-apple fs-5"></i>
                                                        <div className="text-start">
                                                            <div style={{ fontSize: 9, opacity: 0.7 }}>Download on the</div>
                                                            <div>App Store</div>
                                                        </div>
                                                    </a>
                                                    <a
                                                        href="https://play.google.com/store/apps/details?id=com.hilflowpartner"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            display: 'inline-flex', alignItems: 'center', gap: 8,
                                                            background: '#01875f', color: '#fff',
                                                            borderRadius: 10, padding: '10px 18px',
                                                            textDecoration: 'none', fontSize: 13, fontWeight: 600
                                                        }}
                                                    >
                                                        <i className="mdi mdi-google-play fs-5"></i>
                                                        <div className="text-start">
                                                            <div style={{ fontSize: 9, opacity: 0.7 }}>Get it on</div>
                                                            <div>Google Play</div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>

                                    {/* SEKME 4: Alıntılarım (Kullanıcının Teklifleri) */}
                                    <TabPane tabId="4">
                                      <p className="text-muted">
        {isAdmin ? "Sistemdeki tüm teklifler" : "Bu arama kriterleri için " + quotesData.length + " teklifiniz var."}
    </p>
                                        
                                        {isLoadingQuotes ? (
                                            <div className="text-center py-5">
                                                <Spinner color="primary" /> <p className="mt-2">Teklifleriniz yükleniyor...</p>
                                            </div>
                                        ) : quotesData.length > 0 ? (
                                            <TableContainer
                                                columns={quotesColumns}
                                                data={quotesData}
                                                isCustomPageSize={true}
                                                isPagination={true}
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                                            />
                                        ) : (
                                            <div className="text-center text-muted py-5">
                                                Henüz bir teklifiniz bulunmuyor.
                                            </div>
                                        )}
                                    </TabPane>

                                    {/* SEKME 5: Yardım */}
                                    <TabPane tabId="5">
                                        <h4>Sekme "Yakınlarda protracts"</h4>
                                        <p>Bu sekmede, kalkış veya varış adresinin evinize yakınlığına göre size sunabileceğimiz tüm rotaları bulacaksınız...</p>
                                        <h4 className="mt-4">"Benim tırnaklarım" (Alıntılarım) sekmesi</h4>
                                        <ul>
                                            <li><span className="text-warning">● Bekliyor:</span> teklif henüz ekiplerimiz tarafından incelenmedi.</li>
                                            <li><span className="text-success">● Kabul edildi:</span> görev size atandı.</li>
                                            <li><span className="text-danger">● Reddedildi:</span> görev size atanmadı.</li>
                                        </ul>
                                    </TabPane>
                                </TabContent>
                            </Col>
                        </Row>
                    </div>
                </div>


                {/* GELEN TEKLİFLER MODALI */}
            <Modal isOpen={isOffersModalOpen} toggle={toggleOffersModal} size="lg" centered scrollable>
                <ModalHeader toggle={toggleOffersModal} className="bg-light">
                    İlan #{selectedAdvertForOffers?.id} - Gelen Teklifler
                </ModalHeader>
                <ModalBody>
                    {isOffersModalLoading ? (
                        <div className="text-center py-5">
                            <Spinner color="primary" /> <p className="mt-2">Teklifler yükleniyor...</p>
                        </div>
                    ) : selectedAdvertForOffers?.allOffers && selectedAdvertForOffers.allOffers.length > 0 ? (
                        <div className="table-responsive">
                            <Table className="table-sm table-nowrap align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Teklif No</th>
                                        <th>Sürücü Bilgisi</th>
                                        <th>Fiyat / Net / Yol</th>
                                        <th>Tarih / Saat</th>
                                        <th>Durum</th>
                                        <th className="text-end">İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedAdvertForOffers.allOffers.map((offer, index) => {
                                        let badgeColor = "warning";
                                        if (offer.Offer_Status === "Kabul Edildi") badgeColor = "success";
                                        if (offer.Offer_Status === "Reddedildi") badgeColor = "danger";

                                      const parseDur = (dur) => {
                                            if (!dur) return "-";
                                            const m = dur.match(/PT(\d+)H(\d+)M/);
                                            if (!m) return dur;
                                            return `${String(m[1]).padStart(2,'0')}:${String(m[2]).padStart(2,'0')}`;
                                        };

                                        // Yeni Tablodan masraf detaylarını çekiyoruz
                                        const expDetail = (offer.Advert_Expenses && offer.Advert_Expenses.length > 0) ? offer.Advert_Expenses[0] : null;
                                        const totalExp = expDetail ? expDetail.Total_Expense : (offer.Travel_Expenses || 0);

                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <div>#{offer.ID}</div>
                                                    {offer.Quickly && (
                                                        <Badge color="warning" className="mt-1">
                                                            <i className="mdi mdi-flash me-1"></i>Hızlı
                                                        </Badge>
                                                    )}
                                                </td>
                                                <td>
                                                    <span className="fw-medium text-dark d-block">
                                                        {offer.Users ? offer.Users.Users_NameSurname : "Bilinmiyor"}
                                                    </span>
                                                    <span className="text-muted" style={{fontSize: "11px"}}>
                                                        ID: #{offer.Users_ID}
                                                    </span>
                                                </td>
                                             <td>
        <div className="fw-bold text-primary">{Number(offer.Price || 0).toFixed(2)} ₺</div>
        <div className="text-muted" style={{fontSize:"11px"}}>Net: {Number(offer.Own_Offer || 0).toFixed(2)} ₺</div>
        
        {/* YOL VE DETAY BUTONU */}
        <div className="text-muted d-flex align-items-center mt-1" style={{fontSize:"11px"}}>
            <span>Yol: {Number(totalExp).toFixed(2)} ₺</span>
            {totalExp > 0 && (
                <Badge 
                    color="info" 
                    pill 
                    className="ms-2" 
                    style={{cursor: "pointer"}} 
                    onClick={() => openExpenseDetailModal(offer)}
                >
                    <i className="mdi mdi-eye me-1"></i>Detay
                </Badge>
            )}
        </div>
    </td>
                                                <td style={{fontSize:"11px", whiteSpace:"nowrap"}}>
                                                    {offer.Delivery_Date && <div><strong>Bşl:</strong> {new Date(offer.Delivery_Date).toLocaleDateString('tr-TR')}</div>}
                                                    {(offer.Start_Time || offer.End_Time) && (
                                                        <div>{parseDur(offer.Start_Time)} - {parseDur(offer.End_Time)}</div>
                                                    )}
                                                    {offer.DateTime_ && <div><strong>Bit:</strong> {new Date(offer.DateTime_).toLocaleDateString('tr-TR')}</div>}
                                                    {!offer.Delivery_Date && !offer.Start_Time && !offer.DateTime_ && (
                                                        <span>{new Date(offer.Created_DateTime).toLocaleString('tr-TR')}</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <Badge color={badgeColor}>{offer.Offer_Status || "Bekliyor"}</Badge>
                                                    {offer.IsUpdated && <Badge color="info" className="ms-1">Güncellendi</Badge>}
                                                    {offer.Offer_Status === "Reddedildi" && offer.ReasonForRejection && (
                                                        <div className="text-danger mt-1" style={{fontSize: "11px", whiteSpace: "normal", maxWidth: "150px"}}>
                                                            <strong>Neden:</strong> {offer.ReasonForRejection}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="text-end">
                                                    {offer.Quickly ? (
                                                        <Badge color="warning" className="p-2">
                                                            <i className="mdi mdi-flash me-1"></i>Hızlı Teklif
                                                        </Badge>
                                                    ) : (
                                                        <div className="d-flex justify-content-end gap-1">
                                                            <Button
                                                                color="success"
                                                                size="sm"
                                                                disabled={offer.Offer_Status === "Kabul Edildi"}
                                                                onClick={() => handleOfferStatusUpdate(offer.ID, "Kabul Edildi")}
                                                            >
                                                                Kabul Et
                                                            </Button>
                                                            <Button
                                                                color="danger"
                                                                size="sm"
                                                                outline
                                                                disabled={offer.Offer_Status === "Reddedildi"}
                                                                onClick={() => { setRejectModal({ offerId: offer.ID }); setRejectReason(""); }}
                                                            >
                                                                Reddet
                                                            </Button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <div className="text-center text-muted py-4">
                            <i className="mdi mdi-inbox-outline display-4 mb-2"></i>
                            <p>Bu ilan için henüz hiç teklif verilmemiş.</p>
                        </div>
                    )}
                </ModalBody>
            </Modal>

{/* YENİ EKLENEN: TEKLİFİN MASRAF DETAYI MODALI */}
    <Modal isOpen={expenseDetailModalOpen} toggle={() => setExpenseDetailModalOpen(false)} centered>
        <ModalHeader toggle={() => setExpenseDetailModalOpen(false)} className="bg-soft-info">
            <i className="mdi mdi-receipt text-info me-2"></i>Teklifin Masraf Detayları
        </ModalHeader>
        <ModalBody className="p-4">
            {viewExpenseDetail ? (
                <div>
                    {[
                        { icon: "mdi-gas-station", label: "YAKIT MASRAFI", value: viewExpenseDetail.Fuel_Expense },
                        { icon: "mdi-highway", label: "OTOYOL ÜCRETİ", value: viewExpenseDetail.Toll_Fee },
                        { icon: "mdi-bus", label: "TOPLU TAŞIMA", value: viewExpenseDetail.Public_Transport },
                        { icon: "mdi-taxi", label: "TAKSİ GİDERİ", value: viewExpenseDetail.Taxi_Expense },
                        { icon: "mdi-alert-circle-outline", label: "İSTİSNAİ MASRAFLAR", value: viewExpenseDetail.Exceptional_Expense },
                    ].map((item, idx) => (
                        <div key={idx} className="d-flex align-items-center justify-content-between py-2 border-bottom">
                            <div className="d-flex align-items-center">
                                <div className="me-3 rounded p-2" style={{backgroundColor:"#e1f5fe"}}>
                                    <i className={`mdi ${item.icon} text-info fs-5`}></i>
                                </div>
                                <span className="fw-medium text-uppercase" style={{fontSize:"12px"}}>{item.label}</span>
                            </div>
                            <span className="fw-bold">{Number(item.value || 0).toFixed(2)} TL</span>
                        </div>
                    ))}
                    <div className="d-flex justify-content-between align-items-center pt-3 mt-2">
                        <span className="fw-bold text-uppercase fs-6">Genel Toplam Masraf</span>
                        <span className="fw-bold text-danger fs-5">{Number(viewExpenseDetail.Total_Expense || 0).toFixed(2)} TL</span>
                    </div>
                </div>
            ) : (
                <div className="text-center py-4">
                    <i className="mdi mdi-alert-circle-outline text-warning" style={{fontSize: "48px"}}></i>
                    <h5 className="mt-2 text-dark">Detay Bulunamadı</h5>
                    <p className="text-muted">Bu teklife ait detaylı masraf kaydı bulunmuyor.</p>
                </div>
            )}
        </ModalBody>
        <ModalFooter>
            <Button color="light" onClick={() => setExpenseDetailModalOpen(false)}>Kapat</Button>
        </ModalFooter>
    </Modal>

            {/* MASRAFLAR MODALI */}
            <Modal isOpen={isExpensesModalOpen} toggle={toggleExpensesModal} size="lg" centered scrollable>
                <ModalHeader toggle={toggleExpensesModal} className="bg-light">
                    İlan #{selectedAdvertForExpenses?.id} - Masraflar
                </ModalHeader>
                <ModalBody>
                    {isExpensesModalLoading ? (
                        <div className="text-center py-5">
                            <Spinner color="warning" /> <p className="mt-2">Masraflar yükleniyor...</p>
                        </div>
                    ) : selectedAdvertForExpenses?.pricings?.length > 0 ? (
                        <div>
                            <p className="text-muted mb-3">
                                <strong>{selectedAdvertForExpenses.pricings.length}</strong> hizmet kalemi
                            </p>
                            <div className="border rounded">
                                {selectedAdvertForExpenses.pricings.map((p, i) => {
                                    const pricingId = p.Advert_Pricing_ID;
                                    const name = p.Advert_Pricing?.Advert_Pricing_Title
                                        || (pricingId === 1 ? "Araba Yıkama" : pricingId === 2 ? "Araba Bakımı" : pricingId === 3 ? "Görev Ücretlendirmesi" : `Hizmet #${pricingId}`);
                                    const icon = pricingId === 1 ? "mdi-car-wash" : pricingId === 2 ? "mdi-car-wrench" : "mdi-cash-multiple";
                                    return (
                                        <div key={i} className={`d-flex align-items-center py-3 px-3 ${i < selectedAdvertForExpenses.pricings.length - 1 ? "border-bottom" : ""}`}>
                                            <div className="me-3 rounded p-2" style={{ backgroundColor: "#fff3e0" }}>
                                                <i className={`mdi ${icon} text-warning fs-5`}></i>
                                            </div>
                                            <div>
                                                <div className="fw-medium">{name}</div>
                                                <div className="text-muted" style={{ fontSize: "11px" }}>ID: #{p.ID}</div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <div className="text-center text-muted py-4">
                            <i className="mdi mdi-receipt-text-outline display-4 mb-2"></i>
                            <p>Bu ilan için henüz hizmet kalemi eklenmemiş.</p>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            {/* ── Aktif/Pasif Onay Modalı ─────────────────────── */}
            <Modal isOpen={!!confirmToggle} toggle={() => setConfirmToggle(null)} centered size="sm">
                <ModalHeader toggle={() => setConfirmToggle(null)} style={{ borderBottom: "none" }}>
                    <div className="d-flex align-items-center gap-2">
                        <div style={{
                            width: 34, height: 34, borderRadius: 8,
                            background: confirmToggle?.newStatus
                                ? "linear-gradient(135deg,#198754,#2dce89)"
                                : "linear-gradient(135deg,#dc3545,#ff6b6b)",
                            display: "flex", alignItems: "center", justifyContent: "center"
                        }}>
                            <i className={`bx ${confirmToggle?.newStatus ? "bx-check-circle" : "bx-pause-circle"} text-white`} style={{ fontSize: 18 }} />
                        </div>
                        <span style={{ fontWeight: 700 }}>
                            {confirmToggle?.newStatus ? "İlanı Aktif Et" : "İlanı Pasife Al"}
                        </span>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0 pb-3 text-center">
                    <p className="mb-0" style={{ fontSize: 14, color: "#495057" }}>
                        İlan <strong>#{confirmToggle?.id}</strong>'yi{" "}
                        <strong className={confirmToggle?.newStatus ? "text-success" : "text-danger"}>
                            {confirmToggle?.newStatus ? "AKTİF (Onaylı)" : "PASİF (Bekliyor)"}
                        </strong>{" "}
                        duruma getirmek istediğinize emin misiniz?
                    </p>
                </ModalBody>
                <ModalFooter style={{ borderTop: "none", gap: 8 }}>
                    <Button color="light" size="sm" onClick={() => setConfirmToggle(null)} style={{ borderRadius: 8 }}>
                        İptal
                    </Button>
                    <Button
                        color={confirmToggle?.newStatus ? "success" : "danger"}
                        size="sm"
                        onClick={handleToggleConfirm}
                        style={{ borderRadius: 8, fontWeight: 600 }}
                    >
                        {confirmToggle?.newStatus ? "Evet, Aktif Et" : "Evet, Pasife Al"}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* ── Red Nedeni Modalı ───────────────────────────── */}
            <Modal isOpen={!!rejectModal} toggle={() => setRejectModal(null)} centered size="sm">
                <ModalHeader toggle={() => setRejectModal(null)} style={{ borderBottom: "none" }}>
                    <div className="d-flex align-items-center gap-2">
                        <div style={{
                            width: 34, height: 34, borderRadius: 8,
                            background: "linear-gradient(135deg,#dc3545,#ff6b6b)",
                            display: "flex", alignItems: "center", justifyContent: "center"
                        }}>
                            <i className="bx bx-x-circle text-white" style={{ fontSize: 18 }} />
                        </div>
                        <span style={{ fontWeight: 700 }}>Teklifi Reddet</span>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <p className="text-muted mb-2" style={{ fontSize: 13 }}>
                        Teklif <strong>#{rejectModal?.offerId}</strong> reddedilecek. Red nedeni (opsiyonel):
                    </p>
                    <Input
                        type="textarea"
                        rows={3}
                        placeholder="Red nedenini yazın..."
                        value={rejectReason}
                        onChange={e => setRejectReason(e.target.value)}
                        style={{ borderRadius: 8, resize: "none" }}
                    />
                </ModalBody>
                <ModalFooter style={{ borderTop: "none", gap: 8 }}>
                    <Button color="light" size="sm" onClick={() => setRejectModal(null)} style={{ borderRadius: 8 }}>
                        Vazgeç
                    </Button>
                    <Button
                        color="danger"
                        size="sm"
                        style={{ borderRadius: 8, fontWeight: 600 }}
                        onClick={() => {
                            handleOfferStatusUpdate(rejectModal.offerId, "Reddedildi", rejectReason || null);
                            setRejectModal(null);
                        }}
                    >
                        <i className="mdi mdi-close me-1" />Reddet
                    </Button>
                </ModalFooter>
            </Modal>

            </React.Fragment>
        );
    }

    export default UygunGeziler;